import { defineStore } from 'pinia';
import { NotificationService } from '~/services/NotificationService';
import { NotificationRequest, Notification, NotificationsResponse } from '~/models/NotificationModels';
import { API_BASE_URL } from '~/config';
import { HubConnectionBuilder, LogLevel, type IHttpConnectionOptions } from '@aspnet/signalr';

export const useMyNotificationsStore = defineStore({
  id: 'myNotificationsStore',
  state: () => ({
    notifications: {} as Notification[],
    unreadCount: 0 as number,
    notificationsMini: {} as any[],
    hubConnection: null as any,
  }),
  getters: {
    getNotifications(state) {
      return state.notifications;
    },
    getNotificationMini(state) {
      return state.notificationsMini;
    },
    getUnreadCount(state) {
      return state.unreadCount;
    },
  },
  actions: {
    async fetchNotifications(body: NotificationRequest) {
      const notificationService = new NotificationService();

      try {
        const res = await notificationService.GetNotificationsList(body);
        if (res.data.isSuccess) {
          this.notifications = res.data.data.notifications;
          this.unreadCount = res.data.data.unreadCount;
          return true;
        } else {
          toast.error(res.data.message);
          return false;
        }
      } catch (error: any) {
        toast.error(error);
        return false;
      }
    },
    //read all notifications
    async setReadAllNotifications() {
      const notificationService = new NotificationService();

      try {
        const res = await notificationService.ReadAllNotification();
        if (res.data.isSuccess) {
          this.unreadCount = 0;
          this.setSignalRConnection(localStorage.getItem("token") ?? "");
          return true;
        } else {
          toast.error(res.data.message);
          return false;
        }
      } catch (error: any) {
        toast.error(error);
        return false;
      }
    },

    //read notification
    async setReadNotification(id: number) {
      const notificationService = new NotificationService();

      try {
        const res = await notificationService.ReadNotification({ id });
        if (res.data.isSuccess) {
          this.unreadCount--;
          return true;
        } else {
          toast.error(res.data.message);
          return false;
        }
      } catch (error: any) {
        toast.error(error);
        return false;
      }
    },

    async setSignalRConnection(token: string) {
      try {
        const options: IHttpConnectionOptions = {
          accessTokenFactory: () => token,
          skipNegotiation: true,
          transport: 1,
        };

        // Hub bağlantısını oluşturma
        this.hubConnection = new HubConnectionBuilder()
          .withUrl(`${API_BASE_URL}/generalhub/`, options)
          .configureLogging(LogLevel.None)
          .build();

        // Bağlantıyı başlatma
        await this.hubConnection.start();
        // Bildirim eventini dinleme
        this.hubConnection.on('Notifications', (data: any) => {
          this.notificationsMini = data.Notifications;
          this.unreadCount = data.UnreadCount;
        });

      } catch (error) {
        console.error('Bağlantı hatası:', error);
      }
    },
    async endSignalRConnection() {
      if (this.hubConnection) {
        await this.hubConnection.stop()
          .then(() => {
            this.hubConnection = null;
          })
          .catch((error: any) => console.error('Bağlantı sonlandırma hatası:', error));
      } else {
        console.warn('Bağlantı zaten sonlandırılmış veya yok');
      }
    }

  }
});
